<template>
  <div class="container">
    <div class="row">
      <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
      <div class="col-lg-12 text-left">
        <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
      </div>
    </div>
    <b-card>
      <div class="row">
        <div class="col-lg-6 text-left">
          <b-form-group label="Road Trip Title (Required)" label-for="title" class="roadtripField">
            <b-form-input
              v-model="roadtrip.title"
              id="title"
              name="title"
              @change="generateSlug($event)"
              @input="dirty = true"
              :state="submitted && $v.roadtrip.title.$error ? false : null"
            />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.title.required">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a title
            </b-form-invalid-feedback>

            <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.title.$invalid && context === 'edit'">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a title
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Slug (Required)" label-for="slug" class="roadtripField">
            <b-form-input v-model="roadtrip.slug" id="slug" name="slug" @input="dirty = true" :state="submitted && $v.roadtrip.slug.$error ? false : null" />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.slug.required">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a slug
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="!submitted && !isSlugValid">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a valid slug
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !isSlugValid">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a valid slug
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-lg-3 text-left">
          <b-form-group label="Trip Number (Required)" label-for="title" class="roadtripField">
            <b-form-input v-model="roadtrip.trip_number" id="title" name="title" @input="dirty = true" :state="submitted && $v.roadtrip.trip_number.$error ? false : null" />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.trip_number.required">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a trip number
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.trip_number.numeric">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Trip number must be a number
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.trip_number.$invalid && context === 'edit'">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a trip number
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.trip_number.$invalid && !$v.roadtrip.trip_number.numeric">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Trip number must be numeric
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Set Road Trip to Active" label-for="roadtripActive">
            <b-form-checkbox id="roadtripActive" name="roadTripActive" v-model="roadtrip.active" @input="dirty = true" switch>Active</b-form-checkbox>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 text-left">
          <h1>Author</h1>
          <b-form-group label="Author's Name (Required)" label-for="author name" class="roadtripField">
            <b-form-input v-model="roadtrip.author" id="author" name="author" @input="dirty = true" :state="submitted && $v.roadtrip.author.$error ? false : null" />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.author.required">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an author
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.author.$invalid && context === 'edit'">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an author
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Author's Email Address (Required)" label-for="author email" class="roadtripField">
            <b-form-input
              v-model="roadtrip.contact_email"
              id="contact_email"
              name="contact_email"
              @input="dirty = true"
              :state="submitted && $v.roadtrip.contact_email.$error ? false : null"
            />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.contact_email.required">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please a contact email
            </b-form-invalid-feedback>
            <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.contact_email.$invalid && context === 'edit'">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a contact email
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-lg-3 text-left">
          <h1>Featured Road Trip</h1>
          <b-form-group label="Featured Road Trip" label-for="featuredRoadtripActive">
            <b-form-checkbox id="featuredRoadtripActive" name="featuredRoadtripActive" v-model="roadtrip.featured" @input="dirty = true" switch>Active</b-form-checkbox>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 text-left">
          <h1>Content</h1>
          <div class="col-lg-12 text-left contentField">
            <b-form-group label="Teaser (Required)" label-for="teaser" class="text-left">
              <b-form-textarea id="teaser" name="teaser" v-model="roadtrip.teaser" rows="5" max-rows="5" />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.teaser.required">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a teaser
              </b-form-invalid-feedback>
              <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.teaser.$invalid && context === 'edit'">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a teaser
              </b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-lg-12 text-left contentField">
            <b-form-group label="Body (Required)" label-for="body" class="text-left">
              <froala id="body" :tag="'textarea'" :config="config" v-model="roadtrip.body" @input="dirty = true" :state="submitted && $v.roadtrip.body.$error ? false : null" />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.body.required">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a body
              </b-form-invalid-feedback>
              <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.body.$invalid && context === 'edit'">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a body
              </b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-lg-12 text-left contentField">
            <b-form-group label="About (Required)" label-for="about" class="text-left">
              <froala id="about" :tag="'textarea'" :config="config" v-model="roadtrip.about" @input="dirty = true" :state="submitted && $v.roadtrip.about.$error ? false : null" />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.about.required">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an about
              </b-form-invalid-feedback>
              <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.about.$invalid && context === 'edit'">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an about
              </b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="col-lg-12 text-left contentField">
            <b-form-group label="Directions (Required)" label-for="direction" class="text-left">
              <froala
                id="direction"
                :tag="'textarea'"
                :config="config"
                v-model="roadtrip.direction"
                @input="dirty = true"
                :state="submitted && $v.roadtrip.direction.$error ? false : null"
              />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.direction.required">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter directions
              </b-form-invalid-feedback>
              <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.direction.$invalid && context === 'edit'">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter directions
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </div>
      <!-- Regions -->
      <div class="row">
        <div class="col-lg-12 text-left">
          <h1>Regions</h1>
          <div class="regions-section">
            <p>Regions *</p>
            <b-form-group>
              <b-checkbox-group id="regions" name="regions" v-model="roadtrip.region_ids" buttons :state="submitted && roadtrip.region_ids.length < 1 ? false : null">
                <b-checkbox :value="1" class="rounded-pill">North Alabama</b-checkbox>
                <b-checkbox :value="2" class="rounded-pill">Central Alabama</b-checkbox>
                <b-checkbox :value="3" class="rounded-pill">South Alabama</b-checkbox>
                <b-checkbox :value="4" class="rounded-pill">Beaches &amp; Gulf Coast</b-checkbox>
              </b-checkbox-group>
              <b-form-invalid-feedback class="d-block red" v-if="submitted && roadtrip.region_ids.length < 1">At least 1 Region is required</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </div>
      <!-- experience types -->
      <div class="row">
        <div class="col-lg-12 text-left">
          <h1>Experience Types</h1>
          <div class="experiences-section">
            <p>Experiences *</p>
            <b-form-group>
              <b-checkbox-group
                id="experiences"
                name="experiences"
                v-model="roadtrip.experience_ids"
                buttons
                :state="submitted && roadtrip.experience_ids.length < 1 ? false : null"
              >
                <b-checkbox :value="4" class="rounded-pill">Arts &amp; Culture</b-checkbox>
                <b-checkbox :value="2" class="rounded-pill">Beaches</b-checkbox>
                <b-checkbox :value="5" class="rounded-pill">Civil Rights</b-checkbox>
                <b-checkbox :value="3" class="rounded-pill">Food &amp; Drink</b-checkbox>
                <b-checkbox :value="1" class="rounded-pill">History</b-checkbox>
                <b-checkbox :value="6" class="rounded-pill">Music</b-checkbox>
                <b-checkbox :value="8" class="rounded-pill">Outdoors</b-checkbox>
                <b-checkbox :value="9" class="rounded-pill">Science &amp; Discovery</b-checkbox>
                <b-checkbox :value="10" class="rounded-pill">Sports</b-checkbox>
                <b-checkbox :value="7" class="rounded-pill">Year Round Golf</b-checkbox>
              </b-checkbox-group>
              <b-form-invalid-feedback class="d-block red" v-if="submitted && roadtrip.experience_ids.length < 1">At least 1 Experience is required</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 text-left">
          <h1>Don't Miss</h1>
          <div class="col-lg-4 text-left">
            <b-form-group label="Name (Required)" label-for="dontMissName" class="roadtripField">
              <b-form-input
                v-model="roadtrip.dont_miss_name"
                id="dontMissName"
                name="dontMissName"
                @input="dirty = true"
                :state="submitted && $v.roadtrip.dont_miss_name.$error ? false : null"
              />
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.dont_miss_name.required">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a name
              </b-form-invalid-feedback>
              <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.dont_miss_name.$invalid && context === 'edit'">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a name
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="row">
            <div class="col-lg-12 text-left">
              <b-form-group label="Description (Required)" label-for="dontMissDescription" class="text-left contentField">
                <froala
                  id="dont_miss"
                  :tag="'textarea'"
                  :config="config"
                  v-model="roadtrip.dont_miss"
                  @input="dirty = true"
                  :state="submitted && $v.roadtrip.dont_miss.$error ? false : null"
                />
                <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.roadtrip.dont_miss.required">
                  <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a description
                </b-form-invalid-feedback>
                <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.roadtrip.dont_miss.$invalid && context === 'edit'">
                  <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a description
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
          <!-- Map Points -->
          <div class="row">
            <div class="col-lg-12 text-left">
              <div style="display: flex">
                <h1>Map Points</h1>
                <b-form-group label="(Required)" label-for="mapPoints" class="ml-3" style="align-self: flex-end"> </b-form-group>
              </div>

              <b-form-invalid-feedback class="d-block red" v-if="submitted && mapPointError">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />At Least one map point is required.
              </b-form-invalid-feedback>

              <div class="row">
                <div class="col-lg-4">
                  <b-form-group label="Name" label-for="name" class="">
                    <b-form-input v-model="newMapPoint.name" ref="name" id="mapPointName" name="mapPointName" />
                  </b-form-group>
                  <b-form-group label="Address" label-for="address" class="">
                    <b-form-input v-model="newMapPoint.address" ref="address" id="mapPointAddress" name="mapPointAddress" />
                  </b-form-group>
                </div>
                <div class="col-lg-4">
                  <b-form-group label="Slug" label-for="slug" class="">
                    <b-form-input v-model="newMapPoint.slug" ref="slug" id="mapPointSlug" name="mapPointSlug" />
                  </b-form-group>
                  <div class="row">
                    <div class="col-sm-6">
                      <b-form-group label="Lat" label-for="lat" class="">
                        <b-form-input v-model="newMapPoint.latitude" ref="lat" id="mapPointLat" name="mapPointLat" />
                      </b-form-group>
                    </div>
                    <div class="col-sm-6">
                      <b-form-group label="Long" label-for="long" class="">
                        <b-form-input v-model="newMapPoint.longitude" ref="long" id="mapPointLong" name="mapPointLong" />
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="d-flex mt-5 justify-content-center">
                    <b-button id="addMapPoint" :disabled="disableMapPointButton" class="btn btn-secondary" variant="" @click="addMapPoint()">+ Add Map Point</b-button>
                  </div>
                </div>
                <div class="row"></div>

                <!-- List Area -->
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12 text-left">
                      <div class="table-responsive">
                        <table id="mapPointsList" class="table table-sm">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Slug</th>
                              <th>Address</th>
                              <th>Lat</th>
                              <th>Long</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(mapPoint, index) in roadtrip.map_points" :key="mapPoint._id">
                              <td>{{ mapPoint.name }}</td>
                              <td>{{ mapPoint.slug }}</td>
                              <td>{{ mapPoint.address }}</td>
                              <td>{{ mapPoint.latitude }}</td>
                              <td>{{ mapPoint.longitude }}</td>
                              <td>{{ mapPoint.active }}</td>
                              <td><b-button id="deleteMapPoint" class="" @click="deleteMapPoint(index)">x</b-button></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main image photo component -->
          <h1>Images</h1>
          <div class="row">
            <div class="col-lg-4 text-left">
              <p>Main Image (Required)</p>
              <ImageUpload
                :key="mainImageComponentKey"
                v-model="mainImage"
                @input="imageChange($event)"
                @child-imageName="setMainImageName"
                @filenameError="setMainImageFilenameError"
                @fileSizeError="setFileSizeError"
                @child-imageDescription="setMainImageDescription"
                @child-imageContext="removeImage"
                :imageNameInit="mainImage.name"
                :imageDescriptionInit="mainImage.description"
                :context="'main_image'"
                ref="photoUpload"
              >
                <div slot="activator">
                  <div v-if="mainImage.hasInitialImage === false || mainImage.removedImage === true" class="upload-area">
                    <font-awesome-icon icon="cloud-upload-alt" size="3x" class="upload-icon" />
                    <span class="upload-area-text">Drag images to upload or <span style="color: lightskyblue; text-decoration: underline">Browse</span></span>
                  </div>
                  <div v-else>
                    <img :src="mainImage.imageURL" alt="image" class="roadtrip-image" @error="imageLoadError((type = 'main'))" />
                  </div>
                </div>
              </ImageUpload>
              <p class="d-block red" v-if="mainImage.error">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please select an image
              </p>
              <p class="d-block red invalid-feedback" v-if="!mainImage.validFilename">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />
                Filename must not be blank, contain \ / : * ? &#60; &#62; |, spaces or multiple periods and must be of type jpg/jpeg, png, gif
              </p>
            </div>
            <div class="col-lg-4 text-left">
              <p>Featured Road Trip Image (Required)</p>
              <ImageUpload
                :key="featuredImageComponentKey"
                v-model="featuredImage"
                @input="imageChange($event)"
                @child-imageName="setFeaturedImageName"
                @filenameError="setFeaturedImageFilenameError"
                @fileSizeError="setFileSizeError"
                @child-imageDescription="setFeaturedImageDescription"
                @child-imageContext="removeImage"
                :imageNameInit="featuredImage.name"
                :imageDescriptionInit="featuredImage.description"
                :context="'featured_image'"
              >
                <div slot="activator">
                  <div v-if="featuredImage.hasInitialImage === false || featuredImage.removedImage === true" class="upload-area">
                    <font-awesome-icon icon="cloud-upload-alt" size="3x" class="upload-icon" />
                    <span class="upload-area-text">Drag images to upload or <span style="color: lightskyblue; text-decoration: underline">Browse</span></span>
                  </div>
                  <div v-else>
                    <img :src="featuredImage.imageURL" alt="image" class="roadtrip-image" @error="imageLoadError((type = 'featured'))" />
                  </div>
                </div>
              </ImageUpload>
              <p class="d-block red" v-if="featuredImage.error">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please select an image
              </p>

              <p class="d-block red invalid-feedback" v-if="!featuredImage.validFilename">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />
                Filename must not be blank, contain \ / : * ? &#60; &#62; |, spaces or multiple periods and must be of type jpg/jpeg, png, gif
              </p>
            </div>

            <div class="col-lg-4 text-left">
              <p>Don't Miss Image (Required)</p>
              <ImageUpload
                :key="dontMissImageComponentKey"
                v-model="dontMissImage"
                @input="imageChange($event)"
                @child-imageName="setDontMissImageName"
                @filenameError="setDontMissImageFilenameError"
                @fileSizeError="setFileSizeError"
                @child-imageDescription="setDontMissImageDescription"
                @child-imageContext="removeImage"
                :imageNameInit="dontMissImage.name"
                :imageDescriptionInit="dontMissImage.description"
                :context="'dont_miss_image'"
              >
                <div slot="activator">
                  <div v-if="dontMissImage.hasInitialImage === false || dontMissImage.removedImage === true" class="upload-area">
                    <font-awesome-icon icon="cloud-upload-alt" size="3x" class="upload-icon" />
                    <span class="upload-area-text">Drag images to upload or <span style="color: lightskyblue; text-decoration: underline">Browse</span></span>
                  </div>
                  <div v-else>
                    <img :src="dontMissImage.imageURL" alt="image" class="roadtrip-image" @error="imageLoadError((type = 'dontmiss'))" />
                  </div>
                </div>
              </ImageUpload>
              <p class="d-block red" v-if="dontMissImage.error">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please Select an image
              </p>
              <p class="d-block red invalid-feedback" v-if="!dontMissImage.validFilename">
                <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />
                Filename must not be blank, contain \ / : * ? &#60; &#62; |, spaces or multiple periods and must be of type jpg/jpeg, png, gif
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--Validation Feedback Area -->
      <div class="row text-left mt-3 mb-3" style="height: 60px">
        <b-form-invalid-feedback aria-live="polite" class="ml-3 d-block red" v-if="(submitted && $v.$invalid) || formInvalid"
          ><font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Double check the required fields. We don't have
          everything <br />
          <span class="ml-3">we need to save the record.</span></b-form-invalid-feedback
        >
      </div>
      <!--Save-->
      <div class="row">
        <b-button id="saveRoadtripBtn" :disabled="disableButton" class="clear pl-5 pr-5 ml-3 mb-2" @click="saveRoadtrip($event)">Save</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
/* eslint-disable-next-line no-unused-vars */
import { required, requiredIf, numeric } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';
import ImageUpload from '../../components/ImageUpload.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
    ImageUpload,
  },
  data() {
    return {
      filenameError: false,
      fileSizeError: false,
      mapPointError: false,
      context: '',
      formInvalid: false,
      submitted: false,
      imageContext: null,
      disableButton: false,
      disableMapPointButton: true,
      newMapPoint: {
        name: '',
        address: '',
        id: '',
        latitude: '',
        longitude: '',
        road_trip_id: '',
        slug: '',
        _id: '',
        created_at: '',
        updated_at: '',
        position: '',
        isNewMapPoint: true,
      },
      mapPointsToDelete: [],
      mainImage: {
        imageURL: null,
        oldName: null,
        name: null,
        description: null,
        imageFile: null,
        isNewImage: false,
        imageNameChanged: false,
        hasInitialImage: false,
        removedImage: false,
        error: false,
        validFilename: true,
      },
      mainImageComponentKey: 0,
      dontMissImage: {
        imageURL: null,
        oldName: null,
        name: null,
        description: null,
        imageFile: null,
        isNewImage: false,
        imageNameChanged: false,
        hasInitialImage: false,
        removedImage: false,
        error: false,
        validFilename: true,
      },
      dontMissImageComponentKey: 0,
      featuredImage: {
        imageURL: null,
        oldName: null,
        name: null,
        description: null,
        imageFile: null,
        isNewImage: false,
        imageNameChanged: false,
        hasInitialImage: false,
        removedImage: false,
        error: false,
        validFilename: true,
      },
      featuredImageComponentKey: 0,
      roadtrip: {
        _id: null,
        id: null,
        created_at: null,
        updated_at: null,
        trip_number: null,
        featured: false,
        map_type: null,
        site: null,
        title: null,
        currentTitle: null,
        slug: null,
        author: null,
        contact_email: null,
        teaser: null,
        active: false,
        body: null,
        where_to_eat_title: null,
        where_to_stay_title: null,
        what_to_see_title: null,
        dont_miss: null,
        about: null,
        dont_miss_name: null,
        dont_miss_image: null,
        road_trip_id: null,
        main_image: null,
        // main_image_file: null,
        featured_image: null,
        sub_image: null,
        thumbnail_image: null,
        direction: null,
        experience_types: [],
        experience_ids: [],
        regions_road_trips: [],
        map_points: [],
        region_ids: [],
      },
      config: {
        key: `${process.env.VUE_APP_FROALA}`,
        heightMax: 150,
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', '|', 'html', '|', 'undo', 'redo'],
        events: {
          initialized() {},
        },
      },
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['code-block']],
      Breadcrumbs: [
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Roadtrip List',
          href: '/roadtrips',
        },
        {
          text: '',
          active: true,
        },
      ],
    };
  },
  props: {
    roadtripId: {
      type: String,
    },
  },
  validations: {
    roadtrip: {
      title: {
        required,
      },
      slug: {
        required,
      },
      trip_number: {
        required,
        numeric,
      },
      author: {
        required,
      },
      contact_email: {
        required,
      },
      featured: {
        required,
      },
      teaser: {
        required,
      },
      body: {
        required,
      },
      about: {
        required,
      },
      direction: {
        required,
      },
      dont_miss_name: {
        required,
      },
      dont_miss: {
        required,
      },
    },
  },
  computed: {
    isSlugValid() {
      return Boolean(/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(this.roadtrip.slug));
    },
    isDisabled() {
      return this.disableButton;
    },
  },
  watch: {
    newMapPoint: {
      handler(val) {
        // prevent adding a map point if all of the  fields are not filled out.
        const formFields = [
          {
            name: val.name,
            slug: val.slug,
            address: val.address,
            lat: val.lat,
            long: val.longitude,
          },
        ];
        const anyEmpty = formFields.every((v) => v.name === '' || v.slug === '' || v.address === '' || v.lat === '' || v.long === '');

        // if any empty is false, we enable the button
        if (!anyEmpty) {
          this.disableMapPointButton = false;
        } else {
          this.disableMapPointButton = true;
        }
      },
      deep: true,
    },
  },
  async created() {
    try {
      this.isLoading = true;
      this.context = this.$router.currentRoute.fullPath.split('/').pop();
      await Promise.all([this.getRoadtrip()]);
      this.$emit('roadtrips-loaded');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
      this.Breadcrumbs[2].text = this.roadtrip.title;
    }
  },
  mounted() {},
  methods: {
    generateSlug(e) {
      const newSlug = e
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^0-9a-z\s]/gi, '')
        .replace(/ /g, '-')
        .replace(/\\/g, '-')
        .replace(/ \\ /g, '-')
        .replace(/-+/g, '-');
      this.roadtrip.slug = newSlug;
    },
    addMapPoint() {
      const newMapPoint = {
        address: this.newMapPoint.address,
        id: 0,
        _id: 0,
        longitude: this.newMapPoint.longitude,
        latitude: this.newMapPoint.latitude,
        name: this.newMapPoint.name,
        slug: this.newMapPoint.slug,
        position: 1,
        road_trip_id: this.roadtrip.id,
        created_at: new Date(),
        updated_at: new Date(),
        isNewMapPoint: true,
      };
      this.roadtrip.map_points.push(newMapPoint);
    },
    deleteMapPoint(index) {
      if (this.roadtrip.map_points[index]._id !== 0) {
        this.mapPointsToDelete.push(this.roadtrip.map_points[index]._id);
      }

      // remove from the roadtrip.map_points model
      this.roadtrip.map_points.splice(index, 1);
    },
    setMainImageName(params) {
      this.mainImage.name = `${params.imageName}`;
      const ext = params.imageExtension[0];
      const newFileName = `${params.imageName}${ext}`;

      if (this.mainImage.isNewImage) {
        Object.defineProperty(this.mainImage.imageFile, 'name', {
          writable: true,
          value: newFileName,
        });
        this.mainImage.name = `${params.imageName}${ext}`;
        this.mainImage.imageNameChanged = true;
      } else {
        this.mainImage.name = `${params.imageName}${ext}`;
        this.mainImage.imageNameChanged = true;
      }
    },
    setMainImageDescription(params) {
      if (params !== null || params !== '') {
        this.mainImage.description = params;
      }
    },
    setFeaturedImageName(params) {
      this.featuredImage.name = `${params.imageName}`;
      const ext = params.imageExtension[0];
      const newFileName = `${params.imageName}${ext}`;

      if (this.featuredImage.isNewImage) {
        Object.defineProperty(this.featuredImage.imageFile, 'name', {
          writable: true,
          value: newFileName,
        });
        this.featuredImage.name = newFileName;
        this.featuredImage.imageNameChanged = true;
      } else {
        this.featuredImage.name = `${params.imageName}${ext}`;
        this.featuredImage.imageNameChanged = true;
      }
    },
    setFeaturedImageDescription(params) {
      this.featuredImage.description = params;
    },
    setDontMissImageName(params) {
      this.dontMissImage.validFilename = false;
      this.dontMissImage.name = `${params.imageName}`;
      const ext = params.imageExtension[0];
      const newFileName = `${params.imageName}${ext}`;

      if (this.dontMissImage.isNewImage) {
        Object.defineProperty(this.dontMissImage.imageFile, 'name', {
          writable: true,
          value: newFileName,
        });
        this.dontMissImage.name = `${params.imageName}${ext}`;
        this.dontMissImage.imageNameChanged = true;
      } else {
        this.dontMissImage.name = `${params.imageName}${ext}`;
        this.dontMissImage.imageNameChanged = true;
      }
    },
    setDontMissImageDescription(params) {
      this.dontMissImage.description = params;
    },
    setMainImageFilenameError(params) {
      if (params) {
        this.mainImage.validFilename = false;
      } else {
        this.mainImage.validFilename = true;
      }
      if (this.mainImage.validFilename && this.featuredImage.validFilename && this.dontMissImage.validFilename) {
        // if  all 3 now valid we can reenable the save button.
        this.disableButton = false;
      } else {
        // else at  least one is invalid, so keep button disabled.
        this.disableButton = true;
      }
    },
    setFeaturedImageFilenameError(params) {
      if (params) {
        this.featuredImage.validFilename = false;
      } else {
        this.featuredImage.validFilename = true;
      }
      if (this.mainImage.validFilename && this.featuredImage.validFilename && this.dontMissImage.validFilename) {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    },
    setDontMissImageFilenameError(params) {
      if (params) {
        this.dontMissImage.validFilename = false;
      } else {
        this.dontMissImage.validFilename = true;
      }
      if (this.mainImage.validFilename && this.featuredImage.validFilename && this.dontMissImage.validFilename) {
        this.disableButton = false;
      } else {
        this.disableButton = true;
      }
    },
    removeImage(value) {
      if (value === 'main_image') {
        this.mainImage.removedImage = true;
        this.mainImage.isNewImage = false;
        this.mainImage.imageURL = null;
        this.mainImage.name = null;
        this.mainImage.imageFile = null;
        this.mainImage.imageNameChanged = false;
        this.mainImage.hasInitialImage = false;
        this.mainImage.validFilename = true;
        this.forceRerender(value);
      }
      if (value === 'featured_image') {
        this.featuredImage.removedImage = true;
        this.featuredImage.isNewImage = false;
        this.featuredImage.imageURL = null;
        this.featuredImage.name = null;
        this.featuredImage.imageFile = null;
        this.featuredImage.imageNameChanged = false;
        this.featuredImage.hasInitialImage = false;
        this.featuredImage.validFilename = true;
        this.forceRerender(value);
      }
      if (value === 'dont_miss_image') {
        this.dontMissImage.removedImage = true;
        this.dontMissImage.isNewImage = false;
        this.dontMissImage.imageURL = null;
        this.dontMissImage.name = null;
        this.dontMissImage.imageFile = null;
        this.dontMissImage.imageNameChanged = false;
        this.dontMissImage.hasInitialImage = false;
        this.dontMissImage.validFilename = true;
        this.forceRerender(value);
      }
    },
    setFileSizeError(params) {
      this.fileSizeError = params;
    },
    imageChange(e) {
      const context = e.imageContext;
      const imageFile = e.formData.get('file');

      if (context === 'main_image') {
        this.mainImage.imageFile = imageFile;
        this.mainImage.isNewImage = true;
        this.mainImage.validFilename = true;
      }
      if (context === 'featured_image') {
        this.featuredImage.imageFile = imageFile;
        this.featuredImage.isNewImage = true;
        this.featuredImage.validFilename = true;
      }
      if (context === 'dont_miss_image') {
        this.dontMissImage.imageFile = imageFile;
        this.dontMissImage.isNewImage = true;
        this.dontMissImage.validFilename = true;
      }
    },
    forceRerender(component) {
      if (component === 'main_image') {
        this.mainImageComponentKey += 1;
      }
      if (component === 'featured_image') {
        this.featuredImageComponentKey += 1;
      }
      if (component === 'dont_miss_image') {
        this.dontMissImageComponentKey += 1;
      }
    },
    imageLoadError(type) {
      switch (type) {
        case 'main':
          this.mainImage.imageURL = `https://staging-alabama-travel.s3.amazonaws.com/uploads/road_trip/main_image/${this.roadtrip.id}/${this.roadtrip.main_image}`;
          break;
        case 'featured':
          this.featuredImage.imageURL = `https://staging-alabama-travel.s3.amazonaws.com/uploads/road_trip/featured_image/${this.roadtrip.id}/${this.roadtrip.featured_image}`;
          break;
        case 'dontmiss':
          this.dontMissImage.imageURL = `https://staging-alabama-travel.s3.amazonaws.com/uploads/road_trip/dont_miss_image/${this.roadtrip.id}/${this.roadtrip.dont_miss_image}`;
          break;
        default:
      }
    },
    isValidFilename(fname) {
      // eslint-disable-next-line
      const rg1 = /^[^\\/:\*\?"<>\|]+$/; // forbidden characters \ / : * ? " < > |
      const rg2 = /^\./; // cannot start with dot (.)
      const rg3 = /\.(jpe?g|png|gif)$/i; // only jpg/jpeg,png, or gif allowed
      const rg4 = /^[^.\n]*\.[^.\n]*$/; // only one period allowed
      const rg5 = /\s/; // no spaces
      return rg1.test(fname) && !rg2.test(fname) && rg3.test(fname) && rg4.test(fname) && !rg5.test(fname);
    },
    async getRoadtrip() {
      if (this.roadtripId) {
        const roadtripResponse = await axios.get(`${process.env.VUE_APP_ROADTRIPS}/${this.roadtripId}`);
        this.roadtrip = {
          _id: roadtripResponse.data._id,
          id: roadtripResponse.data.id,
          title: roadtripResponse.data.title,
          currentTitle: roadtripResponse.data.title,
          created_at: roadtripResponse.data.created_at,
          updated_at: roadtripResponse.data.updated_at,
          slug: roadtripResponse.data.slug,
          active: JSON.parse(roadtripResponse.data.active.toLowerCase()),
          author: roadtripResponse.data.author,
          contact_email: roadtripResponse.data.contact_email,
          body: roadtripResponse.data.body,
          teaser: roadtripResponse.data.teaser,
          main_image: roadtripResponse.data.main_image,
          main_image_description: roadtripResponse.data.main_image_description,
          thumbnail_image: roadtripResponse.data.thumbnail_image,
          dont_miss: roadtripResponse.data.dont_miss,
          about: roadtripResponse.data.about,
          direction: roadtripResponse.data.direction,
          trip_number: roadtripResponse.data.trip_number,
          featured: JSON.parse(roadtripResponse.data.featured.toLowerCase()),
          map_type: roadtripResponse.data.map_type,
          site: roadtripResponse.data.site,
          main_image_updated_at: roadtripResponse.data.main_image_updated_at,
          thumbnail_image_updated_at: roadtripResponse.data.thumbnail_image_updated_at,
          dont_miss_image: roadtripResponse.data.dont_miss_image,
          dont_miss_description: roadtripResponse.data.dont_miss_description,
          dont_miss_image_updated_at: roadtripResponse.data.dont_miss_image_updated_at,
          what_to_see_title: roadtripResponse.data.what_to_see_title,
          where_to_stay_title: roadtripResponse.data.where_to_stay_title,
          where_to_eat_title: roadtripResponse.data.where_to_stay_title,
          dont_miss_name: roadtripResponse.data.dont_miss_name,
          sub_image: roadtripResponse.data.sub_image,
          featured_image: roadtripResponse.data.featured_image,
          featured_image_description: roadtripResponse.data.featured_image_description,
          featured_image_updated_at: roadtripResponse.data.featured_image_updated_at,
          sub_image_updated_at: roadtripResponse.data.sub_image_updated_at,
          locations: roadtripResponse.data.locations,
          feels: roadtripResponse.data.feels,
          experience_types: roadtripResponse.data.experience_types,
          experience_ids: roadtripResponse.data.experience_ids,
          regions_road_trips: roadtripResponse.data.regions_road_trips,
          map_points: roadtripResponse.data.map_points,
          region_ids: roadtripResponse.data.regions_road_trips.map((x) => x.region_id),
        };
      }
      if (this.roadtrip.main_image) {
        this.mainImage.imageURL = `https://alabama-travel.s3.amazonaws.com/uploads/road_trip/main_image/${this.roadtrip.id}/${this.roadtrip.main_image}`;
        this.mainImage.name = this.roadtrip.main_image;
        this.mainImage.oldName = this.roadtrip.main_image;
        this.mainImage.description = this.roadtrip.main_image_description;
        this.mainImage.hasInitialImage = true;
      } else {
        this.mainImage.hasInitialImage = false;
      }

      if (this.roadtrip.featured_image) {
        this.featuredImage.imageURL = `https://alabama-travel.s3.amazonaws.com/uploads/road_trip/featured_image/${this.roadtrip.id}/${this.roadtrip.featured_image}`;
        this.featuredImage.name = this.roadtrip.featured_image;
        this.featuredImage.oldName = this.roadtrip.featured_image;
        this.featuredImage.description = this.roadtrip.featured_image_description;
        this.featuredImage.hasInitialImage = true;
      } else {
        this.featuredImage.hasInitialImage = false;
      }

      if (this.roadtrip.dont_miss_image) {
        this.dontMissImage.imageURL = `https://alabama-travel.s3.amazonaws.com/uploads/road_trip/dont_miss_image/${this.roadtrip.id}/${this.roadtrip.dont_miss_image}`;
        this.dontMissImage.name = this.roadtrip.dont_miss_image;
        this.dontMissImage.oldName = this.roadtrip.dont_miss_image;
        this.dontMissImage.description = this.roadtrip.dont_miss_description;
        this.dontMissImage.hasInitialImage = true;
      } else {
        this.dontMissImage.hasInitialImage = false;
      }
      this.isLoading = false;
    },

    async saveRoadtrip(event) {
      event.target.innerText = 'Saving...';
      this.formInvalid = false;
      this.submitted = true;
      this.$v.$touch(); // vuelidate validate all

      if (this.roadtrip.region_ids < 1) {
        this.formInvalid = true;
      }

      if (this.roadtrip.experience_ids < 1) {
        this.formInvalid = true;
      }

      if (!this.isSlugValid) {
        this.formInvalid = true;
      }

      if (this.fileSizeError) {
        this.formInvalid = true;
      }

      if (this.roadtrip.map_points.length === 0) {
        this.formInvalid = true;
        this.mapPointError = true;
      }

      // IMAGE validation Checks
      if (!this.mainImage.imageURL) {
        this.mainImage.error = true;
        this.formInvalid = true;
      }

      if (!this.featuredImage.imageURL) {
        this.featuredImage.error = true;
        this.formInvalid = true;
      }

      if (!this.dontMissImage.imageURL) {
        this.dontMissImage.error = true;
        this.formInvalid = true;
      }

      if (this.formInvalid || this.$v.$invalid === true) {
        event.target.innerText = 'Save';
        return;
      }

      this.roadtrip.main_image = this.mainImage.name; // 'main_image' is image filename in the db.
      this.roadtrip.thumbnail_image = this.featuredImage.name; // 'thumbnail_image' same as 'featured_image' currently. production currently uses thumbnail_image for featured_images.
      this.roadtrip.featured_image = this.featuredImage.name;
      this.roadtrip.dont_miss_image = this.dontMissImage.name;

      this.roadtrip.main_image_description = this.mainImage.description;
      this.roadtrip.featured_image_description = this.featuredImage.description;
      this.roadtrip.dont_miss_description = this.dontMissImage.description;

      // if new image  add the id and area to the 'file' obj that will be uploaded for pathing purposes.
      if (this.mainImage.isNewImage) {
        this.mainImage.imageFile.id = this.roadtrip.id;
        this.mainImage.imageFile.area = 'main_image';
        this.mainImage.imageFile.newFile = true;
      }
      if (this.featuredImage.isNewImage) {
        this.featuredImage.imageFile.id = this.roadtrip.id;
        this.featuredImage.imageFile.area = 'featured_image';
        this.featuredImage.imageFile.newFile = true;
      }
      if (this.dontMissImage.isNewImage) {
        this.dontMissImage.imageFile.id = this.roadtrip.id;
        this.dontMissImage.imageFile.area = 'dont_miss_image';
        this.dontMissImage.imageFile.newFile = true;
      }

      // if not a new image but the image name has changed.
      if (!this.mainImage.isNewImage && this.mainImage.imageNameChanged) {
        const fileNameChange = {
          id: this.roadtrip.id,
          area: 'main_image',
          oldName: this.mainImage.oldName,
          newName: this.mainImage.name,
          newFile: false,
        };
        this.$refs.photoUpload.uploadFile(fileNameChange);
      }

      if (!this.featuredImage.isNewImage && this.featuredImage.imageNameChanged) {
        const fileNameChange = {
          id: this.roadtrip.id,
          area: 'featured_image',
          oldName: this.featuredImage.oldName,
          newName: this.featuredImage.name,
          newFile: false,
        };
        this.$refs.photoUpload.uploadFile(fileNameChange);
      }

      if (!this.dontMissImage.isNewImage && this.dontMissImage.imageNameChanged) {
        const fileNameChange = {
          id: this.roadtrip.id,
          area: 'dont_miss_image',
          oldName: this.dontMissImage.oldName,
          newName: this.dontMissImage.name,
          newFile: false,
        };
        this.$refs.photoUpload.uploadFile(fileNameChange);
      }

      // bundle up our new image files, to be uploaded later in uploadFiles()
      const imageFiles = [];
      imageFiles.push(this.mainImage.imageFile);
      imageFiles.push(this.featuredImage.imageFile);
      imageFiles.push(this.dontMissImage.imageFile);

      await Promise.all(
        imageFiles.map(async (file) => {
          if (file) {
            const uploadFile = await this.$refs.photoUpload.uploadFile(file);
            this.roadtrip.id = uploadFile;
          }
        }),
      );

      this.roadtrip.mapPointsToDelete = this.mapPointsToDelete;

      // create context, setting the added map_points road_trip_id
      if (!this.roadtrip.map_points.road_trip_id) {
        const mapPointMod = this.roadtrip.map_points.map((x) => {
          x.road_trip_id = this.roadtrip.id;
          return x;
        });
        this.roadtrip.map_points = mapPointMod;
      }

      const url = this.roadtripId ? `${process.env.VUE_APP_ROADTRIPS}/${this.roadtripId}` : `${process.env.VUE_APP_ROADTRIPS}`;

      try {
        const response = await axios.post(url, { ...this.roadtrip });
        if (response.data.success) {
          const self = this;
          this.$router.push({ name: 'roadtrips list' }, () => {
            setTimeout(() => {
              self.$bvToast.toast('Roadtrip Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
            }, 500);
          });
        } else {
          this.$bvToast.toast(`${JSON.stringify(response.data.message)}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.d-block {
  color: red;
}

.upload-icon {
  vertical-align: middle;
  margin-left: 15px;
  margin-right: 15px;
  color: white;
  stroke: black;
  stroke-width: 0.8rem;
}

.upload-area-text {
}

.upload-area {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: #4e97b2 dashed 1px;
  /* background-color: lightblue; */
  height: 200px;
  opacity: 1;
  filter: alpha(opacity=100);
}

.upload-area:hover {
  opacity: 0.3;
  filter: alpha(opacity=30);
  cursor: pointer;
}

.roadtrip-image {
  border-radius: 20px;
  height: 200px;
  width: 350px;
  opacity: 1;
  filter: alpha(opacity=100);
}

.roadtrip-image:hover {
  opacity: 0.3;
  filter: alpha(opacity=30);
  cursor: pointer;
}

.roadtripField {
  height: 100px;
}

.contentField {
  /* margin-bottom: 40px; */
  height: 300px;
}

.experiences-section >>> .btn-secondary {
  background-color: white;
  color: black;
  font-weight: 500;
  border: 1px solid #4e97b2;
  margin: 0px 20px 10px 0;
  min-width: 175px;
}
.experiences-section >>> .btn-secondary:hover {
  cursor: pointer;
}
.experiences-section >>> .btn-group {
  display: inline;
}
.experiences-section >>> .btn-secondary.active {
  background-color: #4e97b2;
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}

.regions-section >>> .btn-secondary {
  background-color: white;
  color: black;
  font-weight: 500;
  border: 1px solid #4e97b2;
  margin: 0px 20px 10px 0;
  min-width: 175px;
}
.regions-section >>> .btn-secondary:hover {
  cursor: pointer;
}
.regions-section >>> .btn-group {
  display: inline;
}
.regions-section >>> .btn-secondary.active {
  background-color: #4e97b2;
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}
</style>
